/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useGetPermissions } from '@hooks/index';

const hasPermission = ({ permissions, scopes }: { permissions: string[]; scopes: string[]}) => {
  const scopesMap: {[index: string]: boolean } = {};
  scopes.forEach((scope) => {
    scopesMap[scope] = true;
  });

  return permissions?.some((permission) => scopesMap[permission]);
};

type PermissionsGateProps = {
  children: React.ReactNode;
  scopes: string[];
};

const PermissionsGate = ({
  children,
  scopes = [],
}: PermissionsGateProps) => {
  const permissions = useGetPermissions();
  const permissionGranted = hasPermission({ permissions, scopes });

  if (!permissionGranted) return <></>;

  return <>{children}</>;
};

export default PermissionsGate;
